import React, { useState, useContext } from 'react';

import PropTypes from 'prop-types';

const GroupSizeSelectorContext = React.createContext({
  sizeSelection: null,
  setSizeSelection: () => {},
});

export const useGroupSizeSelectorContext = () => {
  return useContext(GroupSizeSelectorContext);
};

export default function GroupSizeSelectorProvider({ children }) {
  const [sizeSelection, setSizeSelection] = useState(null);

  return (
    <GroupSizeSelectorContext.Provider
      value={{
        sizeSelection,
        setSizeSelection,
      }}
    >
      {children}
    </GroupSizeSelectorContext.Provider>
  );
}

GroupSizeSelectorProvider.propTypes = {
  children: PropTypes.node,
};
GroupSizeSelectorProvider.Context = GroupSizeSelectorContext;
